import { API } from 'src/services'
import { freezeItems } from './freezeItems'

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false
  },
  getters: {
  },
  mutations: {
    saveItems(state, payload) {
      state.items = freezeItems(payload)
      state.loading = false
    },
    loading(state, payload) {
      state.loading = Boolean(payload)
    }
  },
  actions: {
    async fetchItems({ commit }) {
      commit('loading', true)

      const result = await API.whbRules.get({
        fields: JSON.stringify(['id', 'id_objectid', 'name'])
      })
      commit('saveItems', result.body.success)
    }
  }
}
